import { makeStyles } from '@material-ui/core';
import { ReactNode } from 'react';

import { useCustomTheme } from '@/hooks/useCustomTheme';

interface OptionListItemContainerProps {
  isChecked: boolean;
  children: ReactNode;
}

interface StyleProps {
  checked: boolean;
  paper: string;
  border: string;
  hover: string;
  radius: number;
}

const useStyles = makeStyles((theme) => ({
  option: ({ checked, paper, border, hover, radius }: StyleProps) => ({
    borderRadius: radius,
    padding: theme.spacing(0, 1),
    marginBottom: theme.spacing(1),
    backgroundColor: checked ? paper : 'transparent',
    boxShadow: checked ? `0 0 0 1px ${border}` : 'none',
    '&:hover': { backgroundColor: checked ? paper : hover },
  }),
}));

export const OptionListItemContainer = ({ isChecked, children }: OptionListItemContainerProps) => {
  const { palette, customBorderRadius } = useCustomTheme();
  const classes = useStyles({
    checked: isChecked,
    paper: palette.background.paper,
    border: palette.grey[200],
    hover: palette.grey[50],
    radius: customBorderRadius.paper,
  });

  return (
    <div className={classes.option} data-option-item>
      {children}
    </div>
  );
};
